'use strict'

cpntMap.set('awe-product-dropdown', {
  props: {
    products: {type: Array, default: []}, // all products
    product: {type: Object, default: null}, // currently selected product
    labelPattern: {type: String, default: 'np'}, // product label
  },
  data: function(){
    return {
      expanded: false, // true to show dropdown
      selIdx: -1, // selection index
      i18n: window.i18n,
      utils: this.$root.Utils,
    }
  },
  computed: {
    // return product list minus the selected one
    prodList: function(){
      return this.products.filter(x => x !== this.product)
    },
    currentLabel: function(){
      if (!this.product)
        return ''
      else{
        return this.utils.buildProductLabel(this.product, this.labelPattern);
      }
    }
  },
  methods: {
    // show/hide dropdown list
    toggle: function(e){
      this.expanded = !this.expanded
      if (this.expanded){
        this.$el.focus()
        this.selIdx = -1
      }
    },

    select: function(e, pdt){
      if (e.type === 'mouseup' && e.which !== 1) // left-click only, right-click/wheel-click not supported
        return

      this.$root.selectProduct(pdt)
      this.expanded = false
    },

    onmouseover: function(e, idx){
      this.selIdx = idx
    },

    onKeyDown: function(e){
      if (this.expanded)
        e.stopPropagation()

      switch(e.key){
        case 'Enter':
          if (this.expanded && this.selIdx !== -1)
            this.$root.selectProduct(this.prodList[this.selIdx])

          this.toggle()
          break
        case 'Escape':
          if (this.expanded)
            this.toggle()
          break
        case 'ArrowUp':
          if (this.expanded){
            this.selIdx = Math.max(--this.selIdx, 0)

            const pdtListNd = this.$el.getElementsByClassName('products')[0]
            const child = pdtListNd.children[this.selIdx]

            // scroll up if the selected item is above the visible area
            if (child.offsetTop < pdtListNd.scrollTop)
              pdtListNd.scrollTop -= pdtListNd.scrollTop - child.offsetTop

            e.preventDefault()
          }
          break
        case 'ArrowDown':
          if (this.expanded){
            this.selIdx = Math.min(++this.selIdx, this.prodList.length - 1)

            const pdtListNd = this.$el.getElementsByClassName('products')[0]
            const child = pdtListNd.children[this.selIdx]
            const childBottomPos = child.offsetTop - pdtListNd.scrollTop + child.clientHeight

            // scroll down if the selected item is below the visible area
            if (childBottomPos > pdtListNd.clientHeight)
              pdtListNd.scrollTop += childBottomPos - pdtListNd.clientHeight

            e.preventDefault()
          }
          break
      }
    }
  },

  template: `
    <div class="product-dropdown" v-bind:class="{expanded: expanded}" v-on:blur="expanded = false"
        v-on:keydown.up.down="onKeyDown" v-on:keyup.esc.enter="onKeyDown"
        tabindex="0" :aria-label="i18n.getString('SELECT_PRODUCT')"
        :aria-activedescendant="selIdx >= 0 ? 'pdt_' + selIdx : null"
    >

      <div class="selection row" v-on:click="toggle" :title="currentLabel" :aria-label="currentLabel">
        <slot name="selection" v-bind:product="product" v-bind:expanded="expanded">
          <div class="img-ctnr" role="presentation" v-if="labelPattern.includes('i')">
            <img loading="lazy"
              :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1&force_format=webp,png'"
              :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 1x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 1.5x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 2x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 3x'"
               :title="currentLabel" :alt="currentLabel">

          </div>
          <div class="info">
            {{currentLabel}}
          </div>
          <span class="arrow" :class="{expanded: expanded}">▼</span>
        </slot>
      </div>

      <transition name="rolldown">
        <ol v-show="expanded" class="products" role="listbox" aria-orientation="vertical">
          <li v-for="(pdt, i) in prodList" class="row" :class="{hover: selIdx === i}" role="option"
            v-on:mouseup="select($event, pdt)" v-on:mousedown="$event.preventDefault()" v-on:mouseover="onmouseover($event, i)"
            :id="'pdt_'+i"
            :aria-current="(i === selIdx).toString()"
            :aria-label="pdt.name + ' '+ pdt.pkg"
          >

            <slot name="option" v-bind:product="pdt">
              <div class="img-ctnr" v-if="labelPattern.includes('i')">
              <img loading="lazy"
                :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1&force_format=webp,png'"
                :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 1x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 1.5x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 2x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1&force_format=webp,png 3x'"
                :title="pdt.name" :alt="pdt.name">
              </div>
              <div class="info">{{utils.buildProductLabel(pdt, labelPattern)}}</div>
            </slot>
          </li>
        </ol>
      </transition>
      <div id="ta-announce" aria-live="polite">{{currentLabel}}</div>
    </div>
  `
})
